import React from 'react';
import { useHistory } from 'react-router-dom';

import { useI18n } from 'i18n';
import { TepReportTable } from './table';
import { ReportSummary } from './report-summary';
import ReportHeader from '../ReportHeader';
import { AllRoutes } from 'constants/routes';
import { ExportControl } from './export-control';

import '../deviceUsages.scss';

export const TepHistory = () => {
  const { f } = useI18n();
  const history = useHistory();

  const onClose = () => history.push(AllRoutes.TepHistoryReport);

  return (
    <div className="report device-usages">
      <ReportHeader
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        title={f('historical report')}
        items={<ExportControl />}
        onClose={onClose}
      />
      <ReportSummary />
      <TepReportTable />
    </div>
  );
};
